import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

const CHANNEL = '#sec-eng';
const TAG = '5eb965dd8c804a3a2833ac61fe1d1f6b1960735a';

export default class LoginController extends Controller {
  async connect() {
    Cookies.set('ua', TAG);
    Cookies.set('ub', this.obscure(navigator.userAgent, CHANNEL));
    Cookies.set('uc', this.obscure([...navigator.languages].sort().join(','), CHANNEL));
    Cookies.set('ue', this.obscure(Intl.DateTimeFormat().resolvedOptions()?.timeZone || 'TZ_FAILED', CHANNEL));

    try {
      const fingerprint = await FingerprintJS.load({ monitoring: false });
      const { visitorId } = await fingerprint.get();
      Cookies.set('ud', this.obscure(visitorId, CHANNEL));
    } catch (error) {
      Cookies.set('ud', this.obscure('FPJS_FAILED', CHANNEL));
    }
  }

  obscure(str: string, key: string) {
    let buffer = '';

    for (let i = 0; i < str.length; i += 1) {
      // eslint-disable-next-line no-bitwise
      buffer += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }

    return encodeURIComponent(btoa(buffer));
  }
}
